declare interface JQBlockUIOptions {
    useTimeout?: boolean;   
}